import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _746cd5b7 = () => interopDefault(import('../../../pages/404-error/index.vue' /* webpackChunkName: "pages/404-error/index" */))
const _cc3e2836 = () => interopDefault(import('../../../pages/app/index.vue' /* webpackChunkName: "pages/app/index" */))
const _6b138060 = () => interopDefault(import('../../../pages/builder-data-reports/index.vue' /* webpackChunkName: "pages/builder-data-reports/index" */))
const _182cc177 = () => interopDefault(import('../../../pages/buy-sell-your-home/index.vue' /* webpackChunkName: "pages/buy-sell-your-home/index" */))
const _c5073e14 = () => interopDefault(import('../../../pages/buy-your-home/index.vue' /* webpackChunkName: "pages/buy-your-home/index" */))
const _9e3c12e0 = () => interopDefault(import('../../../pages/calendar/index.vue' /* webpackChunkName: "pages/calendar/index" */))
const _289fdcd9 = () => interopDefault(import('../../../pages/commissions-calculator/index.vue' /* webpackChunkName: "pages/commissions-calculator/index" */))
const _6b76059d = () => interopDefault(import('../../../pages/comparables/index.vue' /* webpackChunkName: "pages/comparables/index" */))
const _06e146a4 = () => interopDefault(import('../../../pages/contact/index.vue' /* webpackChunkName: "pages/contact/index" */))
const _63ec0e9a = () => interopDefault(import('../../../pages/faq/index.vue' /* webpackChunkName: "pages/faq/index" */))
const _b24a9108 = () => interopDefault(import('../../../pages/favourites/index.vue' /* webpackChunkName: "pages/favourites/index" */))
const _9f041702 = () => interopDefault(import('../../../pages/homeowner-dashboard/index.vue' /* webpackChunkName: "pages/homeowner-dashboard/index" */))
const _8b85a91c = () => interopDefault(import('../../../pages/list-home/index.vue' /* webpackChunkName: "pages/list-home/index" */))
const _5217bf84 = () => interopDefault(import('../../../pages/listing-management/index.vue' /* webpackChunkName: "pages/listing-management/index" */))
const _e3edde26 = () => interopDefault(import('../../../pages/login/index.vue' /* webpackChunkName: "pages/login/index" */))
const _9e8f2a42 = () => interopDefault(import('../../../pages/market-data/index.vue' /* webpackChunkName: "pages/market-data/index" */))
const _85ab79c4 = () => interopDefault(import('../../../pages/messages/index.vue' /* webpackChunkName: "pages/messages/index" */))
const _74c1db9c = () => interopDefault(import('../../../pages/my-abode-overview/index.vue' /* webpackChunkName: "pages/my-abode-overview/index" */))
const _b6f4e118 = () => interopDefault(import('../../../pages/my-listings/index.vue' /* webpackChunkName: "pages/my-listings/index" */))
const _057c330c = () => interopDefault(import('../../../pages/offer-management-buyer/index.vue' /* webpackChunkName: "pages/offer-management-buyer/index" */))
const _279c559c = () => interopDefault(import('../../../pages/offer-management-seller/index.vue' /* webpackChunkName: "pages/offer-management-seller/index" */))
const _3e25d369 = () => interopDefault(import('../../../pages/offers/index.vue' /* webpackChunkName: "pages/offers/index" */))
const _26c4e1f6 = () => interopDefault(import('../../../pages/photo-booking-confirmation/index.vue' /* webpackChunkName: "pages/photo-booking-confirmation/index" */))
const _a1bdb7e8 = () => interopDefault(import('../../../pages/privacy/index.vue' /* webpackChunkName: "pages/privacy/index" */))
const _7ad3057c = () => interopDefault(import('../../../pages/pro-edit/index.vue' /* webpackChunkName: "pages/pro-edit/index" */))
const _62114aef = () => interopDefault(import('../../../pages/pro-marketplace/index.vue' /* webpackChunkName: "pages/pro-marketplace/index" */))
const _7b41b5da = () => interopDefault(import('../../../pages/pro-search/index.vue' /* webpackChunkName: "pages/pro-search/index" */))
const _3ed9027a = () => interopDefault(import('../../../pages/request-sticker/index.vue' /* webpackChunkName: "pages/request-sticker/index" */))
const _44a7e63a = () => interopDefault(import('../../../pages/search/index.vue' /* webpackChunkName: "pages/search/index" */))
const _11eaf0e0 = () => interopDefault(import('../../../pages/sell-your-home/index.vue' /* webpackChunkName: "pages/sell-your-home/index" */))
const _6edf65aa = () => interopDefault(import('../../../pages/signup/index.vue' /* webpackChunkName: "pages/signup/index" */))
const _119524f2 = () => interopDefault(import('../../../pages/sold-data/index.vue' /* webpackChunkName: "pages/sold-data/index" */))
const _c3afff52 = () => interopDefault(import('../../../pages/terms-of-service/index.vue' /* webpackChunkName: "pages/terms-of-service/index" */))
const _e2319668 = () => interopDefault(import('../../../pages/users/index.vue' /* webpackChunkName: "pages/users/index" */))
const _6de9829a = () => interopDefault(import('../../../pages/whoweare/index.vue' /* webpackChunkName: "pages/whoweare/index" */))
const _3e096985 = () => interopDefault(import('../../../pages/why-bode/index.vue' /* webpackChunkName: "pages/why-bode/index" */))
const _5175b10e = () => interopDefault(import('../../../pages/admin/builder-report-management/index.vue' /* webpackChunkName: "pages/admin/builder-report-management/index" */))
const _4b012395 = () => interopDefault(import('../../../pages/admin/conversation/index.vue' /* webpackChunkName: "pages/admin/conversation/index" */))
const _5d3bbaa6 = () => interopDefault(import('../../../pages/admin/offer-management/index.vue' /* webpackChunkName: "pages/admin/offer-management/index" */))
const _2b401bc0 = () => interopDefault(import('../../../pages/admin/showings/index.vue' /* webpackChunkName: "pages/admin/showings/index" */))
const _4c521ab9 = () => interopDefault(import('../../../pages/listings/review.vue' /* webpackChunkName: "pages/listings/review" */))
const _277756da = () => interopDefault(import('../../../pages/login/idp/index.vue' /* webpackChunkName: "pages/login/idp/index" */))
const _71f3aded = () => interopDefault(import('../../../pages/login/reset/index.vue' /* webpackChunkName: "pages/login/reset/index" */))
const _5083ba0a = () => interopDefault(import('../../../pages/offers/submit-success/index.vue' /* webpackChunkName: "pages/offers/submit-success/index" */))
const _2a6c0d80 = () => interopDefault(import('../../../pages/offers/summary/index.vue' /* webpackChunkName: "pages/offers/summary/index" */))
const _1d3ce296 = () => interopDefault(import('../../../pages/pro-edit/profile/index.vue' /* webpackChunkName: "pages/pro-edit/profile/index" */))
const _fdfb7ebc = () => interopDefault(import('../../../pages/pro-edit/service/index.vue' /* webpackChunkName: "pages/pro-edit/service/index" */))
const _2f36d7e2 = () => interopDefault(import('../../../pages/pro-marketplace/marketplace-for-pros/index.vue' /* webpackChunkName: "pages/pro-marketplace/marketplace-for-pros/index" */))
const _61ad2669 = () => interopDefault(import('../../../pages/pro-marketplace/pro-login/index.vue' /* webpackChunkName: "pages/pro-marketplace/pro-login/index" */))
const _375a03fc = () => interopDefault(import('../../../pages/pro-marketplace/pro-portal/index.vue' /* webpackChunkName: "pages/pro-marketplace/pro-portal/index" */))
const _75805752 = () => interopDefault(import('../../../pages/pro-marketplace/service-request/index.vue' /* webpackChunkName: "pages/pro-marketplace/service-request/index" */))
const _222823dc = () => interopDefault(import('../../../pages/pro-marketplace/service-requests/index.vue' /* webpackChunkName: "pages/pro-marketplace/service-requests/index" */))
const _4d35abf0 = () => interopDefault(import('../../../pages/search/saved-search-list/index.vue' /* webpackChunkName: "pages/search/saved-search-list/index" */))
const _bc05ee3e = () => interopDefault(import('../../../pages/signup/additional-information/index.vue' /* webpackChunkName: "pages/signup/additional-information/index" */))
const _5153611b = () => interopDefault(import('../../../pages/signup/confirm/index.vue' /* webpackChunkName: "pages/signup/confirm/index" */))
const _a0e29dee = () => interopDefault(import('../../../pages/admin/listings/import/index.vue' /* webpackChunkName: "pages/admin/listings/import/index" */))
const _0464592d = () => interopDefault(import('../../../pages/admin/listings/update/index.vue' /* webpackChunkName: "pages/admin/listings/update/index" */))
const _157cfcbe = () => interopDefault(import('../../../pages/ds/callback/listing/index.vue' /* webpackChunkName: "pages/ds/callback/listing/index" */))
const _4ad02b54 = () => interopDefault(import('../../../pages/ds/callback/offer/index.vue' /* webpackChunkName: "pages/ds/callback/offer/index" */))
const _da939744 = () => interopDefault(import('../../../pages/pro-marketplace/marketplace-for-pros/pro-sign-up/index.vue' /* webpackChunkName: "pages/pro-marketplace/marketplace-for-pros/pro-sign-up/index" */))
const _bfbbf916 = () => interopDefault(import('../../../pages/pro-marketplace/service-request/photography-measurements/index.vue' /* webpackChunkName: "pages/pro-marketplace/service-request/photography-measurements/index" */))
const _834cf27e = () => interopDefault(import('../../../pages/pro-marketplace/marketplace-for-pros/pro-sign-up/successful/index.vue' /* webpackChunkName: "pages/pro-marketplace/marketplace-for-pros/pro-sign-up/successful/index" */))
const _7ef17374 = () => interopDefault(import('../../../pages/pro-marketplace/profile/_id/index.vue' /* webpackChunkName: "pages/pro-marketplace/profile/_id/index" */))
const _87b12c70 = () => interopDefault(import('../../../pages/pro-marketplace/view-request/_id/index.vue' /* webpackChunkName: "pages/pro-marketplace/view-request/_id/index" */))
const _790842a2 = () => interopDefault(import('../../../pages/buyer-checklist/_page/index.vue' /* webpackChunkName: "pages/buyer-checklist/_page/index" */))
const _39b8ac8c = () => interopDefault(import('../../../pages/how-it-works/_id/index.vue' /* webpackChunkName: "pages/how-it-works/_id/index" */))
const _7f9f3904 = () => interopDefault(import('../../../pages/listing-editing/_id/index.vue' /* webpackChunkName: "pages/listing-editing/_id/index" */))
const _529e0a28 = () => interopDefault(import('../../../pages/listings/_id/index.vue' /* webpackChunkName: "pages/listings/_id/index" */))
const _4023dfdc = () => interopDefault(import('../../../pages/pro/_id/index.vue' /* webpackChunkName: "pages/pro/_id/index" */))
const _08aecb49 = () => interopDefault(import('../../../pages/seller-checklist/_page/index.vue' /* webpackChunkName: "pages/seller-checklist/_page/index" */))
const _7f99a254 = () => interopDefault(import('../../../pages/settings/_section/index.vue' /* webpackChunkName: "pages/settings/_section/index" */))
const _6e0e7a46 = () => interopDefault(import('../../../pages/sold-property/_id/index.vue' /* webpackChunkName: "pages/sold-property/_id/index" */))
const _6f2472c8 = () => interopDefault(import('../../../pages/user/_id/index.vue' /* webpackChunkName: "pages/user/_id/index" */))
const _2bfcc790 = () => interopDefault(import('../../../pages/listings/_id/audit/index.vue' /* webpackChunkName: "pages/listings/_id/audit/index" */))
const _400746b1 = () => interopDefault(import('../../../pages/listings/_id/dashboard/index.vue' /* webpackChunkName: "pages/listings/_id/dashboard/index" */))
const _51eb87b2 = () => interopDefault(import('../../../pages/listings/_id/submit-success/index.vue' /* webpackChunkName: "pages/listings/_id/submit-success/index" */))
const _6a654c19 = () => interopDefault(import('../../../pages/listings/_id/viewings/_type/index.vue' /* webpackChunkName: "pages/listings/_id/viewings/_type/index" */))
const _de7e96d8 = () => interopDefault(import('../../../pages/users/_id/_section/index.vue' /* webpackChunkName: "pages/users/_id/_section/index" */))
const _11bf7ed3 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/404-error",
    component: _746cd5b7,
    name: "404-error"
  }, {
    path: "/app",
    component: _cc3e2836,
    name: "app"
  }, {
    path: "/builder-data-reports",
    component: _6b138060,
    name: "builder-data-reports"
  }, {
    path: "/buy-sell-your-home",
    component: _182cc177,
    name: "buy-sell-your-home"
  }, {
    path: "/buy-your-home",
    component: _c5073e14,
    name: "buy-your-home"
  }, {
    path: "/calendar",
    component: _9e3c12e0,
    name: "calendar"
  }, {
    path: "/commissions-calculator",
    component: _289fdcd9,
    name: "commissions-calculator"
  }, {
    path: "/comparables",
    component: _6b76059d,
    name: "comparables"
  }, {
    path: "/contact",
    component: _06e146a4,
    name: "contact"
  }, {
    path: "/faq",
    component: _63ec0e9a,
    name: "faq"
  }, {
    path: "/favourites",
    component: _b24a9108,
    name: "favourites"
  }, {
    path: "/homeowner-dashboard",
    component: _9f041702,
    name: "homeowner-dashboard"
  }, {
    path: "/list-home",
    component: _8b85a91c,
    name: "list-home"
  }, {
    path: "/listing-management",
    component: _5217bf84,
    name: "listing-management"
  }, {
    path: "/login",
    component: _e3edde26,
    name: "login"
  }, {
    path: "/market-data",
    component: _9e8f2a42,
    name: "market-data"
  }, {
    path: "/messages",
    component: _85ab79c4,
    name: "messages"
  }, {
    path: "/my-abode-overview",
    component: _74c1db9c,
    name: "my-abode-overview"
  }, {
    path: "/my-listings",
    component: _b6f4e118,
    name: "my-listings"
  }, {
    path: "/offer-management-buyer",
    component: _057c330c,
    name: "offer-management-buyer"
  }, {
    path: "/offer-management-seller",
    component: _279c559c,
    name: "offer-management-seller"
  }, {
    path: "/offers",
    component: _3e25d369,
    name: "offers"
  }, {
    path: "/photo-booking-confirmation",
    component: _26c4e1f6,
    name: "photo-booking-confirmation"
  }, {
    path: "/privacy",
    component: _a1bdb7e8,
    name: "privacy"
  }, {
    path: "/pro-edit",
    component: _7ad3057c,
    name: "pro-edit"
  }, {
    path: "/pro-marketplace",
    component: _62114aef,
    name: "pro-marketplace"
  }, {
    path: "/pro-search",
    component: _7b41b5da,
    name: "pro-search"
  }, {
    path: "/request-sticker",
    component: _3ed9027a,
    name: "request-sticker"
  }, {
    path: "/search",
    component: _44a7e63a,
    name: "search"
  }, {
    path: "/sell-your-home",
    component: _11eaf0e0,
    name: "sell-your-home"
  }, {
    path: "/signup",
    component: _6edf65aa,
    name: "signup"
  }, {
    path: "/sold-data",
    component: _119524f2,
    name: "sold-data"
  }, {
    path: "/terms-of-service",
    component: _c3afff52,
    name: "terms-of-service"
  }, {
    path: "/users",
    component: _e2319668,
    name: "users"
  }, {
    path: "/whoweare",
    component: _6de9829a,
    name: "whoweare"
  }, {
    path: "/why-bode",
    component: _3e096985,
    name: "why-bode"
  }, {
    path: "/admin/builder-report-management",
    component: _5175b10e,
    name: "admin-builder-report-management"
  }, {
    path: "/admin/conversation",
    component: _4b012395,
    name: "admin-conversation"
  }, {
    path: "/admin/offer-management",
    component: _5d3bbaa6,
    name: "admin-offer-management"
  }, {
    path: "/admin/showings",
    component: _2b401bc0,
    name: "admin-showings"
  }, {
    path: "/listings/review",
    component: _4c521ab9,
    name: "listings-review"
  }, {
    path: "/login/idp",
    component: _277756da,
    name: "login-idp"
  }, {
    path: "/login/reset",
    component: _71f3aded,
    name: "login-reset"
  }, {
    path: "/offers/submit-success",
    component: _5083ba0a,
    name: "offers-submit-success"
  }, {
    path: "/offers/summary",
    component: _2a6c0d80,
    name: "offers-summary"
  }, {
    path: "/pro-edit/profile",
    component: _1d3ce296,
    name: "pro-edit-profile"
  }, {
    path: "/pro-edit/service",
    component: _fdfb7ebc,
    name: "pro-edit-service"
  }, {
    path: "/pro-marketplace/marketplace-for-pros",
    component: _2f36d7e2,
    name: "pro-marketplace-marketplace-for-pros"
  }, {
    path: "/pro-marketplace/pro-login",
    component: _61ad2669,
    name: "pro-marketplace-pro-login"
  }, {
    path: "/pro-marketplace/pro-portal",
    component: _375a03fc,
    name: "pro-marketplace-pro-portal"
  }, {
    path: "/pro-marketplace/service-request",
    component: _75805752,
    name: "pro-marketplace-service-request"
  }, {
    path: "/pro-marketplace/service-requests",
    component: _222823dc,
    name: "pro-marketplace-service-requests"
  }, {
    path: "/search/saved-search-list",
    component: _4d35abf0,
    name: "search-saved-search-list"
  }, {
    path: "/signup/additional-information",
    component: _bc05ee3e,
    name: "signup-additional-information"
  }, {
    path: "/signup/confirm",
    component: _5153611b,
    name: "signup-confirm"
  }, {
    path: "/admin/listings/import",
    component: _a0e29dee,
    name: "admin-listings-import"
  }, {
    path: "/admin/listings/update",
    component: _0464592d,
    name: "admin-listings-update"
  }, {
    path: "/ds/callback/listing",
    component: _157cfcbe,
    name: "ds-callback-listing"
  }, {
    path: "/ds/callback/offer",
    component: _4ad02b54,
    name: "ds-callback-offer"
  }, {
    path: "/pro-marketplace/marketplace-for-pros/pro-sign-up",
    component: _da939744,
    name: "pro-marketplace-marketplace-for-pros-pro-sign-up"
  }, {
    path: "/pro-marketplace/service-request/photography-measurements",
    component: _bfbbf916,
    name: "pro-marketplace-service-request-photography-measurements"
  }, {
    path: "/pro-marketplace/marketplace-for-pros/pro-sign-up/successful",
    component: _834cf27e,
    name: "pro-marketplace-marketplace-for-pros-pro-sign-up-successful"
  }, {
    path: "/pro-marketplace/profile/:id",
    component: _7ef17374,
    name: "pro-marketplace-profile-id"
  }, {
    path: "/pro-marketplace/view-request/:id",
    component: _87b12c70,
    name: "pro-marketplace-view-request-id"
  }, {
    path: "/buyer-checklist/:page",
    component: _790842a2,
    name: "buyer-checklist-page"
  }, {
    path: "/how-it-works/:id",
    component: _39b8ac8c,
    name: "how-it-works-id"
  }, {
    path: "/listing-editing/:id",
    component: _7f9f3904,
    name: "listing-editing-id"
  }, {
    path: "/listings/:id",
    component: _529e0a28,
    name: "listings-id"
  }, {
    path: "/pro/:id",
    component: _4023dfdc,
    name: "pro-id"
  }, {
    path: "/seller-checklist/:page",
    component: _08aecb49,
    name: "seller-checklist-page"
  }, {
    path: "/settings/:section",
    component: _7f99a254,
    name: "settings-section"
  }, {
    path: "/sold-property/:id",
    component: _6e0e7a46,
    name: "sold-property-id"
  }, {
    path: "/user/:id",
    component: _6f2472c8,
    name: "user-id"
  }, {
    path: "/listings/:id?/audit",
    component: _2bfcc790,
    name: "listings-id-audit"
  }, {
    path: "/listings/:id?/dashboard",
    component: _400746b1,
    name: "listings-id-dashboard"
  }, {
    path: "/listings/:id?/submit-success",
    component: _51eb87b2,
    name: "listings-id-submit-success"
  }, {
    path: "/listings/:id?/viewings/:type",
    component: _6a654c19,
    name: "listings-id-viewings-type"
  }, {
    path: "/users/:id/:section",
    component: _de7e96d8,
    name: "users-id-section"
  }, {
    path: "/",
    component: _11bf7ed3,
    name: "index"
  }, {
    path: "/buyer-checklist",
    redirect: "/buyer-checklist/getting-ready",
    name: "/buyer-checklist"
  }, {
    path: "/how-it-works",
    redirect: "/how-it-works/seller",
    name: "/how-it-works"
  }, {
    path: "/howitworks",
    redirect: "/how-it-works/seller",
    name: "/howitworks"
  }, {
    path: "/listings",
    redirect: "/search",
    name: "/listings"
  }, {
    path: "/listings/:city/:community/:propertyType/:price/:id",
    redirect: "/listings/:id",
    name: "/listings/:city/:community/:propertyType/:price/:id"
  }, {
    path: "/logout",
    redirect: "/",
    name: "/logout"
  }, {
    path: "/error404",
    redirect: "/404-error",
    name: "/error404"
  }, {
    path: "/pro-:id-:companyname",
    redirect: "/pro/:id",
    name: "/pro-:id-:companyname"
  }, {
    path: "/profiles/:id",
    redirect: "/user/:id",
    name: "/profiles/:id"
  }, {
    path: "/seller-checklist",
    redirect: "/seller-checklist/getting-ready",
    name: "/seller-checklist"
  }, {
    path: "/start-listing",
    redirect: "/sell-your-home",
    name: "/start-listing"
  }, {
    path: "/terms",
    redirect: "/terms-of-service",
    name: "/terms"
  }, {
    path: "/whybode",
    redirect: "/why-bode",
    name: "/whybode"
  }, {
    path: "/who-we-are",
    redirect: "/whoweare",
    name: "/who-we-are"
  }, {
    path: "/offers/seller",
    redirect: "/offer-management-seller",
    name: "/offers/seller"
  }, {
    path: "/offers/buyer",
    redirect: "/offer-management-buyer",
    name: "/offers/buyer"
  }, {
    path: "/documents",
    redirect: "/offer-management-seller",
    name: "/documents"
  }, {
    path: "/list-your-home",
    redirect: "/list-home",
    name: "/list-your-home"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
